import { useEffect, useState } from 'react';

// Replaces bricks-next `useMedia().largerThanSM` (SM = min-width: 768px). Kept
// only for the JS branching that renders different components on mobile vs
// desktop (MenuPanel, AccountMenu); presentational responsiveness uses Tailwind
// `md:`/`max-md:` classes instead. Starts `false` so the server and first client
// render agree (hydration-safe), then resolves to the real match in an effect.
// Both branched components render hidden/closed content, so the pre-resolve frame
// has no visible effect regardless of viewport.
export const useLargerThanSM = (): boolean => {
  const [largerThanSM, setLargerThanSM] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const mediaQuery = window.matchMedia('(min-width: 768px)');
    const update = () => setLargerThanSM(mediaQuery.matches);
    update();
    mediaQuery.addEventListener('change', update);
    return () => mediaQuery.removeEventListener('change', update);
  }, []);

  return largerThanSM;
};
